'use client';

import { useEffect } from 'react';

export default function PWASetup() {
  useEffect(() => {
    // Service worker registration is intentionally disabled to avoid /sw.js 404 errors.

    // Handle install prompt
    let deferredPrompt: any;
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      deferredPrompt = e;
      // You can show a custom install button here
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  return null;
}

